import React from 'react';
import { complement, both } from 'ramda';

import FormSection from 'containers/FormSectionContainer';
import FieldSet from 'containers/FieldSetContainer';
import ConditionalSection from 'containers/ConditionalSection';
import FormField from 'containers/FormField';
import Datepicker from 'components/Datepicker';
import TextFieldBox from 'components/TextFieldBox';
import TriggerField from 'components/TriggerField';
import SelectField from 'components/SelectField';
import LinkValueInput from 'components/LinkValueInput';

import { oneOf, fieldIsType, fieldIs } from 'lib/conditions';

import FormProvider from 'routes/Documents/containers/FormProvider';

import SearchField from './SearchField';
import DiagnosisText from './DiagnosisText';

const diagnosisTypes = [
  { value: 'comorbidity', label: 'comorbidity.opts.comorbidity' },
  { value: 'infection', label: 'comorbidity.opts.infection' },
  { value: 'procedure', label: 'comorbidity.opts.procedure' },
];

const ComorbidityForm = props => (
  <FormProvider {...props}>
    <FormSection localeId="comorbidity.sections.verifiedDiagnosisDate">
      <FieldSet localeId="comorbidity.labels.diagnosisDate">
        <FormField name="diagnosisDate" component={Datepicker} />
      </FieldSet>
    </FormSection>
    <FormSection localeId="comorbidity.sections.otherChronicDisease">
      <ConditionalSection condition={complement(fieldIsType('diagnosis', String))}>
        <FieldSet localeId="comorbidity.labels.diagnosisType">
          <FormField
            name="diagnosisType"
            component={SelectField}
            hintLocale="comorbidity.hints.diagnosisType"
            options={diagnosisTypes}
          />
        </FieldSet>
      </ConditionalSection>
      <ConditionalSection condition={fieldIsType('diagnosis', String)}>
        <FieldSet localeId="comorbidity.labels.diagnosisType.chosen">
          <FormField name="diagnosisType" component={DiagnosisText} isStatic />
        </FieldSet>
      </ConditionalSection>
      <ConditionalSection condition={fieldIsType('diagnosis', String)}>
        <FieldSet localeId="comorbidity.labels.diagnosis">
          <FormField name="diagnosis" component={SearchField} isStatic />
          <div style={{ marginTop: '1rem' }}>
            <FormField
              name="diagnosis"
              component={TriggerField}
              setValueTo={null}
              condensed
              border
              secondary
              localeId="dictionary.edit"
            />
          </div>
        </FieldSet>
      </ConditionalSection>
      <ConditionalSection
        condition={both(complement(fieldIsType('diagnosis', String)), fieldIs('diagnosisType', 'comorbidity'))}
      >
        <FieldSet localeId="comorbidity.labels.searchAndChoose">
          <FormField
            name="diagnosis"
            component={SearchField}
            hintLocale="comorbidity.hints.search"
            fullWidth
            multiLine
            type="comorbidity"
          />
        </FieldSet>
      </ConditionalSection>
      <ConditionalSection
        condition={both(complement(fieldIsType('diagnosis', String)), fieldIs('diagnosisType', 'infection'))}
      >
        <FieldSet localeId="comorbidity.labels.searchAndChoose">
          <FormField
            name="diagnosis"
            component={SearchField}
            hintLocale="comorbidity.hints.search"
            fullWidth
            multiLine
            type="infection"
          />
        </FieldSet>
      </ConditionalSection>
      <ConditionalSection
        condition={both(complement(fieldIsType('diagnosis', String)), fieldIs('diagnosisType', 'procedure'))}
      >
        <FieldSet localeId="comorbidity.labels.searchAndChoose">
          <FormField
            name="diagnosis"
            component={SearchField}
            hintLocale="comorbidity.hints.search"
            fullWidth
            multiLine
            type="procedure"
          />
        </FieldSet>
      </ConditionalSection>

      <ConditionalSection
        condition={both(
          oneOf('diagnosisType', ['comorbidity', 'infection', 'procedure']),
          complement(fieldIs('diagnosis', 'comorbidity.diagnosis.other')),
        )}
      >
        <FieldSet localeId="comorbidity.labels.other">
          <FormField
            name="diagnosis"
            component={LinkValueInput}
            linkValue="comorbidity.diagnosis.other"
            linkText="comorbidity.otherDiagnosis.clickHere"
          />
        </FieldSet>
      </ConditionalSection>

      <ConditionalSection condition={fieldIs('diagnosis', 'comorbidity.diagnosis.other')}>
        <FieldSet localeId="comorbidity.labels.otherDiagnosisDetail">
          <FormField
            name="otherDetail"
            component={TextFieldBox}
            hintLocale="dictionary.otherWhat"
            viewStyle={{ width: '100%', maxWidth: '40rem' }}
          />
        </FieldSet>
      </ConditionalSection>
    </FormSection>
  </FormProvider>
);

export default ComorbidityForm;
